import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import moment from 'moment';

export const UptimeTable = ({ data = [] }) => {
  const [openDates, setOpenDates] = useState({});

  const toggleDate = date => {
    setOpenDates(prev => ({
      ...prev,
      [date]: !prev[date]
    }));
  };

  return (
    <div className="space-y-3">
      {data.map(day => (
        <div
          key={day.date}
          className="rounded-xl border bg-white shadow-sm"
        >
          <div
            onClick={() => toggleDate(day.date)}
            className="flex cursor-pointer items-center justify-between px-4 py-3"
          >
            <span className="text-sm font-semibold text-primary-dark">{day.date}</span>

            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-500">
                {day.events.length} ocorrência{day.events.length > 1 && 's'}
              </span>

              <FiChevronDown className={`card__icon transition ${openDates[day.date] ? 'rotate-180' : ''}`} />
            </div>
          </div>

          {openDates[day.date] && day.events.length > 0 && (
            <div className="px-4 pb-4">
              <div className="flex gap-6 rounded-xl bg-gray-50 p-4">
                <div className="relative flex flex-col items-start gap-3 pl-2">
                  {day.events.map((event, i) => {
                    const time = moment(event['started-at']).format('HH:mm');

                    return (
                      <div
                        key={i}
                        className="relative z-10 flex items-center gap-2"
                      >
                        <div className="h-2 w-2 rounded-full bg-gray-400" />
                        <span className={`text-gray-500} text-center text-sm`}>{time}</span>
                      </div>
                    );
                  })}
                </div>

                <div className="flex flex-1 justify-center">
                  <div className="flex flex-col items-start gap-3">
                    {day.events.map((event, i) => (
                      <span
                        key={i}
                        className="text-sm text-gray-500"
                      >
                        Duração: {event['duration-human']}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col items-end gap-2">
                  {day.events.map((event, i) => (
                    <span
                      key={i}
                      className={`badge badge--small ${event.service === 'api' ? 'badge--primary' : 'badge--info'}`}
                    >
                      {event.service.toUpperCase()}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
